import { create } from "zustand";
import api from "../services/api";

export const useVehiclesStore = create((set, get) => ({
  vehicles: [],
  loading: false,
  error: null,

  fetchVehicles: async () => {
    set({ loading: true });
    try {
      const { data } = await api.get("/v1/vehicles");
      set({ vehicles: data, loading: false });
    } catch (err) {
      set({ error: err.message, loading: false });
    }
  },

  createVehicle: async (payload) => {
    const { data } = await api.post("/v1/vehicles", payload);
    set((s) => ({ vehicles: [...s.vehicles, data.vehicle] }));
  },

  updateVehicle: async (id, payload) => {
    const { data } = await api.put(`/v1/vehicles/${id}`, payload);
    set((s) => ({
      vehicles: s.vehicles.map((v) => (v.id === id ? data.vehicle : v)),
    }));
  },

  deleteVehicle: async (id) => {
    if (!window.confirm("Delete this vehicle?")) return;
    await api.delete(`/v1/vehicles/${id}`);
    set((s) => ({ vehicles: s.vehicles.filter((v) => v.id !== id) }));
  },

  linkVehicle: async (id, payload) => {
    try {
      const { data } = await api.post(`/v1/vehicles/${id}/link`, payload);
      set((s) => ({
        vehicles: s.vehicles.map((v) => (v.id === id ? data.vehicle : v)),
      }));
    } catch (err) {
      alert(`Error linking vehicle: ${err.message}`);
    }
  },
}));
